export default __webpack_public_path__ + "static/media/dashboradStatIconHover.919cd331.svg";